const useIsMobile = () => {
  return window.innerWidth <= 900;
};

export default useIsMobile;
